<script context="module">
	const key = Symbol()
	export { key }
</script>

<script>
	import { setContext } from 'svelte'
	let cls = 'w-full'
	let tdcls = ''
	let td_padding = ''
	let td_border = ''
	let thcls = ''
	let th_padding = ''
	let th_border = ''

	export { cls, tdcls, thcls, td_padding, td_border, th_padding, th_border }

	setContext(key, {
		tdcls: tdcls,
		td_padding: td_padding,
		td_border: td_border,
		thcls: thcls,
		th_padding: th_padding,
		th_border: th_border
	})
</script>

<table class={cls}>
	{#if $$slots.thead}
		<thead>
			<slot name="thead" />
		</thead>
	{/if}
	<tbody>
		<slot name="tbody" />
	</tbody>
</table>
